var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.61 25.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    className: "cls-1",
    d: "M12.84,0A12.79,12.79,0,1,0,23.42,19.92a12.54,12.54,0,0,0,2.19-7.08A12.86,12.86,0,0,0,12.84,0Zm0,23.34A10.55,10.55,0,1,1,23.36,12.79v0A10.59,10.59,0,0,1,12.82,23.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    className: "cls-1",
    d: "M12.38,15.73c-1.24-.08-1.19-.08-1.15-1.33a3.5,3.5,0,0,1,1.46-3c.25-.18.45-.42.69-.61.49-.37.78-.79.51-1.41a1.48,1.48,0,0,0-1.58-.7A1.68,1.68,0,0,0,10.94,10c-.13.46-.34.59-.8.48a4.4,4.4,0,0,0-1.09-.14c-.66,0-.68-.35-.57-.84a3.75,3.75,0,0,1,3.44-2.85,5.12,5.12,0,0,1,2.75.46,3,3,0,0,1,1.66,3.84A2.84,2.84,0,0,1,15.6,12a10.72,10.72,0,0,1-1.27,1.16,1.73,1.73,0,0,0-.67,1.43C13.64,15.82,13.61,15.82,12.38,15.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    className: "cls-1",
    d: "M12.44,19.62a1.19,1.19,0,0,1-1.2-1.2h0v-.06a1.19,1.19,0,0,1,1.2-1.19h0a1.25,1.25,0,0,1,1.25,1.23h0a1.24,1.24,0,0,1-1.27,1.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.f2471d898ef3e930b5c553f1650b06f5.svg";
export { ForwardRef as ReactComponent };